import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mobileNo'
})
export class MobileNo implements PipeTransform {

  transform(value: string, symbol: any): string {
    if(value){
        const endNumber = String(value).slice(-3);
        const restrictedNumber = endNumber.padStart(String(value).length, symbol);
        return restrictedNumber;
    }
    else return '---';
  }
}
